
import Vue from 'vue';
import {mapState} from 'vuex';
import AlertStore from './store';

const Alert =  {
    name: 'Alert',
    data() {
		return {};
	},
    computed: mapState({
        title: (state) => state.Alert.title,
        show: (state) => state.Alert.show,
        text: (state) => state.Alert.text,
        buttonText: (state) => state.Alert.buttonText,
        align: (state) => state.Alert.align,
        callback: (state) => state.Alert.callback,
        closeBtn: (state) => state.Alert.closeBtn,
    }),
    created() {
        if (!this.$store.state.Alert) {
            this.$store.registerModule('Alert', AlertStore);
        }
    },
    methods: {
        close() {
            this.$store.commit('Alert/close');
        },
        submit() {
            this.$store.commit('Alert/close');
            if(this.callback) {
                this.callback();
            }
        }
    }
};

export default Alert;



// WEBPACK FOOTER //
// ./src/ui/alert/index.js